import { FaBoxes, FaBullhorn, FaChartLine, FaFlag, FaHandshake, FaPalette, FaPhoneAlt, FaStore, FaTruck } from "react-icons/fa";
import Navbar from "./Navbar";
import { BiLocationPlus, BiMailSend } from "react-icons/bi";
import { CgMail } from "react-icons/cg";
import { MdCall } from "react-icons/md";
import { CiLocationArrow1 } from "react-icons/ci";
import { GoLocation } from "react-icons/go";
import Footer from "./Footer";
import { db } from "./Firebase";
import { BsWhatsapp } from "react-icons/bs";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";

export default function Distributor() {

    const features = [
        { icon: <FaFlag size={28} />, title: "100% Made in India", desc: "In-house manufacturing with uncompromised quality control" },
        { icon: <FaPalette size={28} />, title: "Trending & Timeless Designs", desc: "From rugged jeans to versatile shorts and capris" },
        { icon: <FaChartLine size={28} />, title: "Competitive Dealer Margins", desc: "High returns with fast-moving products" },
        { icon: <FaBoxes size={28} />, title: "Ready Stock Availability", desc: "Consistent inventory to meet your demand" },
        { icon: <FaTruck size={28} />, title: "Pan-India Shipping Support", desc: "Prompt and secure logistics" },
        { icon: <FaBullhorn size={28} />, title: "Marketing Support", desc: "Brand visuals, promotions & retail setup assistance" },
    ];

    const containn = [
        { number: "10+", name: "Years of Excellence" },
        { number: "100%", name: "Made in India" },
        { number: "500+", name: "Happy Partners" },
        { number: "24 - 48h", name: "Response Time" },
    ]

    const cardd = [
        { icon: <CgMail className="text-light p-1 bg-warning rounded-circle" size={32} />, name: "Email us", href: "mailto:rinksdenim715@gmail.com", info: "rinksdenim715@gmail.com" },
        { icon: <MdCall className="text-light p-1 bg-warning rounded-circle" size={32} />, name: "Call us", href: "tel:+91-9517909090", info: "+91-9517909090" },
        { icon: <GoLocation className="text-light p-1 bg-warning rounded-circle" size={32} />, name: "Visit us", href: "", info: "A-36/2, Phase-1, Naraina Industrial New Delhi, Delhi, 110028" },
    ]

    const carddd2 = [
        { name: "🛒 MOQ for First-time Dealers", description: "Flexible minimum order quantities based on your business size and location" },
        { name: "📦 Sample Orders", description: "Try our products with sample orders before committing to larger quantities" },
        { name: "🗺️ Regional Exclusivity", description: "Exclusive territory rights based on order volumes and commitment levels" },
    ]

    const form = useRef();

    function submitdata(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);

        var user_name = data.get("user_name");
        var business_name = data.get("business_name");
        var citystate = data.get("citystate");
        var number = data.get("number");
        var user_email = data.get("user_email");
        var enquirytype = data.get("enquirytype");
        var businesstype = data.get("businesstype");
        var user_message = data.get("user_message");
        var status = "Pending";
        var currentDate = new Date().toISOString().split("T")[0];

        db.collection("mainform").add({
            Name: user_name,
            Businessname: business_name,
            Citystate: citystate,
            Number: number,
            Email: user_email,
            Enquirytype: enquirytype,
            Businesstype: businesstype,
            Message: user_message,
            Status: status,
            Date: currentDate

        }).then((succ) => {
            emailjs.send(
                "service_au88fqt",
                "template_pwy7qpo",
                {
                    user_name: user_name,
                    business_name: business_name,
                    citystate: citystate,
                    number: number,
                    user_email: user_email,
                    enquirytype: enquirytype,
                    businesstype: businesstype,
                    user_message: user_message,
                    status: status,
                    currentDate: currentDate
                },
                "gUnN-9-20wDT-HQAL"
            ).then(() => {
                alert("Enquiry Submitted! We will be contacting you in 24-48 hours.");
                e.target.reset();
                e.target.name.focus();
            });
        });
    }

    const [message, setMessage] = useState("");
    const [enquiryType, setEnquiryType] = useState("");

    const presetMessages = {
        "Bulk Order": "I am interested in placing a bulk order. Please provide pricing and MOQ details.",
        "Distributor": "I would like to apply for a distributorship. Kindly share the process and requirements.",
        "Retailer": "I am a retailer interested in your products. Please send product and pricing information.",
    };

    const handlePresetClick = (type) => {
        setEnquiryType(type);
        setMessage(presetMessages[type]);
    };

    const handleEnquiryTypeChange = (e) => {
        const selectedType = e.target.value;
        setEnquiryType(selectedType);
        if (presetMessages[selectedType]) {
            setMessage(presetMessages[selectedType]);
        }
    };

    return (
        <>
            <title>Hack98 Distributor | Wholesale Jeans Partnership</title>
            <meta name="description" content="Join the Hack98 distributor program. Start your jeans business with bulk denim supply, wholesale opportunities, and premium support." />
            <meta name="keywords" content="jeans distributor program, denim business opportunity, wholesale jeans distributor India, denim reseller partnership, premium jeans distributor, denim contact supplier, jeans enquiry online, wholesale jeans manufacturer India, bulk jeans supplier, denim order support, wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans, menswear near me, jeans near me, denims for men, denims for boys near me" />

            <meta property="og:title" content="Hack98 Distributor | Wholesale Jeans Partnership" />
            <meta property="og:site_name" content="Hack98" />
            <meta property="og:url" content="https://hack98.club/Distributor" />
            <meta property="og:description" content="Join the Hack98 distributor program. Start your jeans business with bulk denim supply, wholesale opportunities, and premium support." />
            <meta property="og:image" content="images /logoo.jpeg" />

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@" />
            <meta name="twitter:description" content="Join the Hack98 distributor program. Start your jeans business with bulk denim supply, wholesale opportunities, and premium support." />
            <meta name="twitter:app:country" content="India" />

            <div className="navbarrrr">
                <Navbar />
            </div>
            <section className="bg-primary text-white py-5 margintopdist">
                <div className="container">
                    {/* Top Section */}
                    <div className="row align-items-center justify-content-around text-center text-md-start">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3">
                                <h1 className="fw-bold mb-0 display-6">🤝 Partner with Hack98</h1>
                            </div>
                            <p className="mb-1 lead">Join the Hack98 Network — Be a Part of India’s Premium Denim Revolution</p>
                            <small className="smallll">
                                Since 2014, Hack98 has been a trusted name in men’s denim wear — proudly designed, manufactured, and distributed from our
                                state-of-the-art facility in Delhi. We are now expanding our reach and looking to build strong, long-term partnerships with
                                distributors, retailers, franchisees, and bulk buyers across India.
                            </small>

                            <div className="d-flex gap-3 flex-wrap mt-3">
                                <button className="btn btn-light text-dark d-flex align-items-center"
                                    onClick={() => {
                                        const formSection = document.getElementById("distributor-form");
                                        if (formSection) formSection.scrollIntoView({ behavior: "smooth" });
                                    }}
                                >
                                    <FaStore className="me-2" /> Become a Dealer
                                </button>
                                <a
                                    href="tel:+91-9517909090"><button className="btn btn-outline-light d-flex align-items-center">
                                        <FaPhoneAlt className="me-2" /> Contact Us
                                    </button>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-4 text-center mt-4 mt-md-0">
                            <div className="bg-primary text-light fw-bold rounded-4 py-4 px-4 d-inline-block">
                                <img src="images/award.png" alt="Award Icon" className="awardiconn" />
                                <h5 className="mb-1 fw-bold">Since 2014</h5>
                                <p className="mb-0 small">Trusted Quality</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <section className="text-white py-5 bgcolordist">
                <div className="container">
                    <div className="row text-center text-white mt-5">
                        {containn.map((row) => (
                            <div className="col-6 col-md-3 mb-3">
                                <h3 className="fw-bold text-warning">{row.number}</h3>
                                <p className="mb-0">{row.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section >
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="btn btn-primary fixed-join-btn text-light fw-bold px-4 py-2 shadow rounded-pill me-2" onClick={() => { const formSection = document.getElementById("distributor-form"); if (formSection) formSection.scrollIntoView({ behavior: "smooth" }); }}>
                    + JOIN NOW
                </button>
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor" onClick={() => window.open("https://wa.me/919517909090?text=Hi%2C%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me%3F", "_blank")}>
                    <BsWhatsapp size={24} />
                </button>
            </div>
            <section className="py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">
                            <span role="img" aria-label="flag">🧵</span> Why Partner with Hack98?
                        </h2>
                    </div>
                    <div className="row g-4">
                        {features.map((item, index) => (
                            <div key={index} className="col-md-4">
                                <div className="bg-white rounded shadow shadowww p-4 h-100 text-dark">
                                    <div className="mb-3 text-primary">{item.icon}</div>
                                    <h5 className="fw-bold">{item.title}</h5>
                                    <p className="mb-0 small text-muted">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section id="distributor-form" className="py-5 bg-light">
                <div className="container">
                    <div className="d-flex justify-content-center">
                        <div className="col-lg-6 shadow rounded p-4 bg-white">
                            <div className="mb-4 text-center">
                                <h4 className="fw-bold text-primary">📝 Dealership Enquiry Form</h4>
                                <p className="text-muted mb-0">Ready to join hands with Hack98? Fill out the form below and our team<br />will get in touch within 24–48 hours.</p>
                            </div>
                            <form onSubmit={submitdata}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Name</label>
                                        <input name="user_name" type="text" className="form-control" placeholder="Your Full Name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Business Name</label>
                                        <input name="business_name" type="text" className="form-control" placeholder="Your Business Name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">City & State</label>
                                        <input name="citystate" type="text" className="form-control" placeholder="e.g., Mumbai, Maharashtra" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Contact Number</label>
                                        <input name="number" type="tel" className="form-control" placeholder="Your Phone Number" required />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Email Address</label>
                                        <input name="user_email" type="email" className="form-control" placeholder="example@email.com" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Type of Enquiry</label>
                                        <select name="enquirytype" className="form-select" value={enquiryType} onChange={handleEnquiryTypeChange} required>
                                            <option value="">Select Type</option>
                                            <option value="Distributor">Distributor</option>
                                            <option value="Retailer">Retailer</option>
                                            <option value="Bulk Order">Bulk Order</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Business Type</label>
                                        <select name="businesstype" className="form-select" required>
                                            <option value="">Select Business Type</option>
                                            <option>Retail Store</option>
                                            <option>Online Seller</option>
                                            <option>Wholesaler</option>
                                            <option>Exporter</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">
                                            Message / Specific Requirements
                                            <div className="dropdown d-inline ms-2">
                                                <button className="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Choose Preset
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <button className="dropdown-item" type="button" onClick={() => handlePresetClick("Bulk Order")}>Bulk Order</button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item" type="button" onClick={() => handlePresetClick("Distributor")}>Distributorship</button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item" type="button" onClick={() => handlePresetClick("Retailer")}>Retailer</button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </label>
                                        <textarea name="user_message" className="form-control" rows="4" placeholder="Tell us about your business requirements, expected order volumes, etc." value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                                    </div>
                                    <div className="col-12 text-center">
                                        <button type="submit" className="btn btn-primary px-4 mt-3 rounded-pill fw-bold">
                                            📩Submit Enquiry
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">
                            <span role="img" aria-label="call">📞</span> Get in Touch Directly
                        </h2>
                        <p>Prefer speaking to someone directly? We're just a call or message away</p>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {cardd.map((row) => (
                            <div className="col-lg-4 col-md-6 col-sm-10">
                                <div className="card shadow h-100">
                                    <div className="text-center p-4">
                                        {row.icon}
                                        <h5 className="text-dark mt-3 fw-bold">{row.name}</h5>
                                        <p>
                                            <a href={row.href} className="text-primary text-decoration-none fw-bold">{row.info}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">
                            <span role="img" aria-label="call">📃</span> Minimum Order Requirements
                        </h2>
                        <p className="">We offer flexible options depending on your business type. Our team will guide you on:</p>
                        <div className="row g-3 mt-3">
                            {carddd2.map((row) => (
                                <div className="col-12">
                                    <div className="p-3 bg-white border-start border-3 border-warning rounded shadow-sm">
                                        <h6 className="mb-1">
                                            <strong>{row.name}</strong>
                                        </h6>
                                        <p className="mb-0 text-muted">
                                            {row.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5 bg-primary">
                <div className="container">
                    <div className="text-center">
                        <h2 className="fw-bold">
                            <span role="img" aria-label="call">🚀</span>&nbsp;
                            <span className="text-light">Lets grow together</span>
                        </h2>
                        <p className="mt-3 text-light">Whether you're starting a new retail venture or adding to your existing portfolio, Hack98 is here to support your journey. With <br /> unmatched quality, modern designs, and reliable service - we're more than a denim brand. We're partner in your success.</p>
                        <button className="btn btn-light mt-2">
                            🤝 Become a Distributor Now
                        </button>
                    </div>
                </div>
            </section>
            <div className="row m-0 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>
        </>
    )
}